import { render, staticRenderFns } from "./FraudPrevention.vue?vue&type=template&id=5b2c5164&scoped=true"
import script from "./FraudPrevention.vue?vue&type=script&lang=js"
export * from "./FraudPrevention.vue?vue&type=script&lang=js"
import style0 from "./FraudPrevention.vue?vue&type=style&index=0&id=5b2c5164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c5164",
  null
  
)

export default component.exports